import React from 'react';
import {
    DialogActions,
    Button,
    CircularProgress,
    useTheme,
    useMediaQuery
} from '@mui/material';
import { styles } from './CryptoModalActionsCss';

const CryptoModalActions = ({
    onClose,
    onSubmit,
    loading
}) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <DialogActions sx={styles.dialogActions(isMobile, theme)}>
            <Button
                onClick={onClose}
                variant={isMobile ? "outlined" : "text"}
                size={isMobile ? "large" : "medium"}
                sx={styles.cancelButton(isMobile)}
            >
                Cancel
            </Button>
            <Button
                variant="contained"
                onClick={onSubmit}
                disabled={loading}
                size={isMobile ? "large" : "medium"}
                sx={styles.submitButton(isMobile, theme)}
                startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
            >
                Add Crypto Wallet
            </Button>
        </DialogActions>
    );
};

export default CryptoModalActions;
